import React from 'react';
import { Col, Button, Form, Select } from 'antd';

const EnvironmentalForm = ({ formname, formData, setFormData, onHndleFinish }) => {
  const handleSelectChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Form
      name={formname}
      layout='inline'
      onFinish={onHndleFinish}
      className='filterTabs'
      style={{
        width: '100%',
        paddingTop: '25px',
        paddingBottom: '25px',
        justifyContent: 'start',
        backgroundColor: '#FFF',
      }}
    >
      {/* <Col span={4} xs={24} sm={24} lg={24} xl={16} style={{ textAlign: 'start' }}>
                <Form.Item label="Lot Number" style={{ width: '100%', margin: 0 }}>
                    <Input
                        onChange={(e) => handleInputChange(e, 'lotNumber')}
                        value={formData.lotNumber}
                    />
                </Form.Item>
            </Col>
            <hr /> */}
      <Col span={4} xs={24} sm={24} lg={24} xl={16} style={{ textAlign: 'start' }}>
        <Form.Item label='Select Source' style={{ width: '100%', marginBottom: 20 }}>
          <Select
            onChange={(value) => handleSelectChange(value, 'thing')}
            placeholder='Select'
            value={formData.thing}
            options={[
              {
                value: '17',
                label: 'Mems Photonics Systems entities',
              },
              {
                value: '19',
                label: 'EO Markers entities',
              },
            ]}
          />
        </Form.Item>

        <Form.Item style={{ width: '100%', alignItems: 'start' }}>
          <Button
            className='btnPrimary'
            disabled={!formData.thing}
            type='primary'
            htmlType='submit'
            style={{ padding: '22px 20px', backgroundColor: formData.thing ? '#335001' : '#d9d9d9' }}
          >
            Filter
          </Button>
        </Form.Item>
      </Col>
    </Form>
  );
};

export default EnvironmentalForm;
